export default "__VITE_ASSET__BZcckveU__"